import React, { useLayoutEffect, useState } from "react";
import classes from "./ScrollToTop.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
const ScrollToTop = () => {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);

  const visible = scrolled ? " " + classes.Visible : "";
  useLayoutEffect(() => {
    const handleScroll = (e) => {
      setScrolled(window.scrollY > window.outerHeight / 2);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  let _content = !scrolled ? null : (
    <button
      title={t("global.scroll_to_top")}
      tabIndex="0"
      className={classes.ScrollToTop + visible}
      onClick={() => {
        window.scrollTo(0, 0);
      }}
    >
      <FontAwesomeIcon icon={faArrowUp} />
    </button>
  );
  return _content;
};

export default ScrollToTop;
